// author : xyl
// editdate : 20230530
// rem : 项目私有方法，程序员可根据需要进行修改。

import { loginButtonPublic, AutoLoginState, GetUserInfoWithNoCPZS, ProductId, EnterProduct, RedirectUrl, readData, Route_qcpt, execServiceApiSync, getUserInfo, isOpenVerifyCode } from '@/assets/js/fstsign.js'
import { ElMessageBox } from 'element-plus';
import store from '@/store';

// let currentInstance;

/**
 * 返回页面文件路径及名称。为登录成功后的首页。此参数由开发人员定义
 */
export function getMainPage() {
    // if(!currentInstance){
    //      currentInstance = getCurrentInstance()
    // }
    const role = store.state.role
    if (role == '2') {
        return "/bacinfo";
    } else {
        return "/adminindex";
    }
}

/**
 * 登录方法,登录成功跳转至首页,同时返回true；失败显示错误信息并返回false
 * @param {string} accountValue 账号输入框内容
 * @param {string} passwordValue 密码输入框内容
 */
export async function loginButton(accountValue, passwordValue, vccodeValue) {
    if (accountValue == "" || passwordValue == "") {
        ElMessageBox.alert('账号或密码不允许为空！', '提示信息', {
            confirmButtonText: '确定',
            type: 'error',
            callback: action => {}
        })
        return false;
    }
    else if (isOpenVerifyCode && vccodeValue === ""){
        ElMessageBox.alert('验证码不能为空！', '提示信息', {
            confirmButtonText: '确定',
            type: 'error',
            callback: action => {}
        })
        return false;
    } else {
        return await loginButtonPublic(accountValue, passwordValue, vccodeValue);
    }
}


/////////////////////////////////////////////////////////////////////
///　以下建立多个内容相同的跳转方法，是供程序员跳转时个性化设置。///
////////////////////////////////////////////////////////////////////

/**
 * 用户登录成功后执行的内容（登录页加载学生班级、或者案例之类的在此处调整）
 * @param {string} cUrl 页面url 
 */
export async function redirectWindow(cUrl) {
    //自动登录取出账号以及角色
    if (AutoLoginState) {
        var oRet = await GetUserInfoWithNoCPZS();
        if (oRet.retCode == "0") {
            currentInstance.exposed.username.value = oRet.userId
        } else {
            return ElMessageBox.alert(oRet.Msg, '提示信息', {
                confirmButtonText: '确定',
                type: 'error'
            })
        }
    }
    //进入系统
    EnterProduct(cUrl,"","");
    // var roleV = store.state.role,
    //     userZh = currentInstance.exposed.username.value;
    // if (ProductId != "9999" && roleV == "2") {
    //     //学生 进行选班级（加载班级列表）
    //     GetStuClass(userZh, function (data) {
    //         if (data.length == 0) {
    //             currentInstance.exposed.isShowMask.value = false
    //             return ElMessageBox.alert('暂无实训班级。', '提示信息', {
    //                 confirmButtonText: '确定',
    //                 type: 'error'
    //             })
    //         } else if (data.length == 1) {
    //             //只有一个班级直接进入
    //             EnterProduct(cUrl, data[0].TeachingNO, data[0].ClassName)
    //         } else {
    //             currentInstance.exposed.classData.value = data
    //             currentInstance.exposed.classValue.value = data[0].TeachingNO
    //             //隐藏登录框，显示选择班级
    //             currentInstance.exposed.isShowLogin.value = false
    //             currentInstance.exposed.isShowMask.value = false
    //         }
    //     })
    // } else {
    //     //进入系统
    //     EnterProduct(cUrl);
    // }
}

/**
 * 注销产品证书后跳转页面
 * @param {string} cUrl 页面url 
 */
export function logoutWindow(cUrl) {
    RedirectUrl(cUrl);
}

/**
 * 注销登录证书后跳转页面
 * @param {string} cUrl 页面url 
 */
export function userlogoutWindow(cUrl) {
    RedirectUrl(cUrl);
}

/**
 * 检查登录证书无效跳转页面
 * @param {string} cUrl 页面url 
 */
export function DLZSAvailabilityWindow(cUrl) {
    RedirectUrl(cUrl);
}

/**
 * 获取学生所在的班级（可以调整为由产品中再进行过滤班级或追加其他参数，例如追加考试号之类等）
 * @param {String} userZh 学生账号
 * @param {Function} successCallBack 回调函数，班级数据中的对象必须带（"TeachingNO","ClassName"） [{"TeachingNO":"【教学班编号】",ClassName:"【教学班名次】",...(产品后端自行处理追加字段)},...]
 */
async function GetStuClass(userZh, successCallBack) {
    let userData = readData();
    var PSJ = JSON.stringify({ lx: "99990001", dlzs: userData, pid: ProductId, xh: userZh, TakeEffect: "true" })
    const res = await execServiceApiSync(Route_qcpt, "POST", PSJ)
    if (res.retCode == 0) {
        successCallBack(JSON.parse(res.data));
    } else {
        return ElMessageBox.alert(res.Msg, '提示信息', {
            confirmButtonText: '确定',
            type: 'error'
        })
    }
}

/**
 * 进入系统前的验证操作，被EnterProduct调用
 * @param {String} [teachingNO] 学生教学班号
 * @param {String} [className] 学生教学班名称
 * @returns {Boolean} True验证通过，False验证未通过
 */
export function VerifyBeforeEnterProduct(teachingNO, className) {
    var isPass = true;
    const role = store.state.role
    if (AutoLoginState) {
        return true;
    }
    // if (ProductId != "9999") {
    //     //学生登录需要先选班级
    //     if (role == "2" && !teachingNO) {
    //         ElMessageBox.alert('请选择班级', '提示信息', {
    //             confirmButtonText: '确定',
    //             type: 'error'
    //         })
    //         isPass = false;
    //         return isPass;
    //         // return true;
    //     }
    // }
    return isPass;
}

/**
 * 添加完成产品证书进入系统前的执行函数（需同步执行），被EnterProduct调用
 * 教师或学生系统首页不同的可在此处进行最后一次调整系统首页
 * @param {String} cUrl 首页地址（由EnterProduct传入直接带过来）
 * @returns {String} 必须返回系统首页地址
 */
export async function BeforeEnterProduct(cUrl) {
    //跳转至系统前需执行的内容
    var oUser = await getUserInfo();
    //通过角色判断跳转到的页面
    if (oUser.retCode == 0) {
        var jUser = JSON.parse(oUser.user);
        if (jUser.role == '2') {
            cUrl = "/bacinfo";
        } else {
            cUrl = "/adminindex";
        }
    } else {
        var jUser = JSON.parse(oUser.user);
        if (jUser.role == '2') {
            cUrl = "/login";
        } else {
            cUrl = "/adminlogin";
        }
    }
    currentInstance = null
    return cUrl;
}

/**
 * @method 验证码图片显示
 */
export function ShowVCodeCallBack(oRet){
    currentInstance.exposed.vccode.value = '';
    currentInstance.exposed.vcCodeSrc.value = oRet.VCode.Image || "";
}
